import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import { RentalPortalViewingFormModal } from '../../../../RentalPortalViewing'

export function useCreateRentalPortalViewing({ setModal, onClose, onReload }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  function handleCreated(createdCount) {
    handleAddSuccessNotification(
      t('RentalPortal.ViewingsAddedNotificationKey', { count: createdCount })
    )

    onReload()
  }

  function handleBooked() {
    handleAddSuccessNotification('RentalPortal.ViewingBookedNotificationKey')

    onReload()
  }

  function handleOpenCreate(start) {
    setModal(
      <RentalPortalViewingFormModal
        start={start}
        onBooked={handleBooked}
        onClose={onClose}
        onCreated={handleCreated}
      />
    )
  }

  function handleOpenBooking(viewing) {
    setModal(
      <RentalPortalViewingFormModal
        slot={viewing}
        onBooked={handleBooked}
        onClose={onClose}
        onCreated={handleCreated}
      />
    )
  }

  return { handleOpenBooking, handleOpenCreate }
}
